import { useReveal } from "@/hooks/useReveal";

const benefits = [
    "Confianza al vestir",
    "Claridad en tu estilo",
    "Presencia en eventos y trabajo",
    "Coherencia entre quién eres y cómo te ven",
];

export default function Beneficios() {
    const { ref, visible } = useReveal();

    return (
        <section
            id="beneficios"
            data-testid="beneficios-section"
            className="relative py-28 md:py-40 bg-[#D8B9A7]/55 overflow-hidden"
        >
            <div className="blur-shape w-[420px] h-[420px] bg-[#C6A76A]/30 -top-32 -left-32" />

            <div
                ref={ref}
                className={`relative max-w-[1400px] mx-auto px-6 md:px-10 lg:px-16 reveal ${visible ? "is-visible" : ""}`}
            >
                <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-16 items-start">
                    <div className="lg:col-span-4">
                        <div className="flex items-center gap-4 mb-6">
                            <span className="section-number">Beneficios</span>
                            <span className="h-px w-12 bg-[#1E1E1E]/40" />
                        </div>
                        <h2
                            data-testid="beneficios-title"
                            className="font-display text-[44px] md:text-[64px] leading-[1.05] text-[#1E1E1E] tracking-[-0.02em]"
                        >
                            Lo que vas a{" "}
                            <span className="font-italic-display">sentir.</span>
                        </h2>
                        <p className="mt-6 max-w-sm text-[#1E1E1E]/70 leading-relaxed">
                            No es solo verse mejor — es habitar tu imagen con la misma certeza con la que tomas tus decisiones.
                        </p>
                    </div>

                    <div className="lg:col-span-8">
                        <div className="grid sm:grid-cols-2 gap-6 md:gap-8">
                            {benefits.map((b, i) => (
                                <div
                                    key={b}
                                    data-testid={`beneficio-${i}`}
                                    className="group relative bg-[#F7F3EE] p-8 md:p-10 transition-all duration-500 hover:bg-[#1E1E1E] hover:text-[#F7F3EE]"
                                >
                                    <div className="flex items-baseline justify-between mb-6">
                                        <span className="font-display italic text-[#C6A76A] text-3xl md:text-4xl">
                                            0{i + 1}
                                        </span>
                                        <span className="w-10 h-px bg-[#1E1E1E]/30 group-hover:bg-[#C6A76A] transition-colors duration-500" />
                                    </div>
                                    <p className="font-display text-2xl md:text-[28px] leading-tight tracking-tight">
                                        {b}
                                    </p>
                                </div>
                            ))}
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
}
